export default {
    "Van Cranenbroek": "Van Cranenbroek",
    "Menu": "Menu",
    "What are you looking for?": "What are you looking for?",
    "back": "back",
    "Filtering": "Filtering",
    "Clear all": "Clear all",
    "Show more": "Show more",
    "Show less": "Show less",
    "Price": "Price",
    "to": "to",
    "Enter a correct value": "Enter a correct value",
    "Popularity": "Popularity",
    "Newest": "Newest",
    "Yes": "Yes",
    "No": "No",
    "Name (A-Z)": "Name (A-Z)",
    "Name (Z-A)": "Name (Z-A)",
    "Price (Ascending)": "Price (Ascending)",
    "Price (Descending)": "Price (Descending)",
    "Categories": "Categories",
    "Apply": "Apply",
    "No products were found in this category.": "No products were found in this category.",
    "Discount valid from {start} to {end}": "Discount valid from {start} to {end}",
    "More info": "More info",
    "Subscribe to our newsletter": "Subscribe to our newsletter",
    "Yes i subscribe!": "Yes I subscribe!",
    "Follow us": "Follow us",
    "Compare products": "Compare products",
    "Compare": "Compare",
    "Edit": "Edit",
    "Change password": "Change password",
    "Contact information": "Contact information",
    "Personal information": "Personal information",
    "Opening Hours": "Opening Hours",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Coffee corner": "Coffee corner",
    "Extra information": "Extra information",
    "Phone": "Phone",
    "Special opening hours": "Special opening hours",
    "No special opening hours": "No special opening hours",
    "Subject to change. Deviating opening hours (holidays etc.) are listed below under Special opening hours.": "Subject to change. Deviating opening hours (holidays etc.) are listed below under Special opening hours.",
    "E-mailadress": "E-mail address",
    "Subject": "Subject",
    "Select a subject": "Select a subject",
    "Store": "Store",
    "Stores": "Stores",
    "No specific store": "No specific store",
    "Question": "Question",
    "Fields marked with * are required.": "Fields marked with * are required.",
    "Submit contact request": "Submit contact request",
    "Addition": "Addition",
    "Declaration of conformity": "Declaration of conformity",
    "Download": "Download",
    "House number": "House number",
    "First name": "First name",
    "Last name": "Last name",
    "Phone number": "Phone number",
    "The {_field_} field must be selected.": "The {_field_} field must be selected.",
    "The subject field must be selected.": "The subject field must be selected.",
    "Your message has been sent": "Your message has been sent",
    "In Stock in {count} store(s)": "In stock in {count} store(s)",
    "I accept": "I accept",
    "Valid until": "Valid until",
    "Sort by": "Sort by",
    "Show store": "Show store",
    "Chosen filters": "Chosen filters",
    "Show {totalItems} results": "Show {totalItems} results",
    "Sidebar menu - Quick Access": "Sidebar menu - Quick Access",
    "Quick access to": "Quick access to",
    "Call": "Call",
    "Atmospheric image of": "Atmospheric image of",
    "In stock": "In stock",
    "Specifications": "Specifications",
    "There was a problem with the subscription: This email address is already subscribed.": "There was a problem with the subscription: This email address is already subscribed.",
    "Thank you for your subscription.": "Thank you for your subscription.",
    "Choose your {option}": "Choose your {option}",
    "Other variants": "Other variants",
    "Remove from wishlist": "Remove from wishlist",
    "Select an option to show stock information": "Select an option to show stock information",
    "Promotion till": "Promotion till",
    "Out of stock": "Out of stock",
    "In stock in {count} store(s)": "In stock in {count} store(s)",
    "Other Variants": "Other variants",
    "{count} items in stock": "{count} items in stock",
    "Less then {count} items in stock": "Less than {count} items in stock",
    "Others also viewed": "Others also viewed",
    "Frequently asked questions": "Frequently asked questions",
    "Most asked questions": "Most asked questions",
    "Where are you searching for?": "What are you searching for?",
    "Search on subject": "Search on subject",
    "This is what we found": "This is what we found",
    "Product description": "Product description",
    "Privacy checkbox is required": "Privacy checkbox is required",
    "We didn't found any results": "We didn't find any results",
    "Sorry, we couldn't find anything based on your search. Please change your search request, or search by category for your question.": "Sorry, we couldn't find anything based on your search. Please change your search request, or search by category for your question.",
    "Contact": "Contact",
    "Complaints? We\u2019re here to help!": "Complaints? We\u2019re here to help!",
    "We\u2019re sorry to hear that you have a complaint. We will do our best to resolve this as soon as possible.": "We\u2019re sorry to hear that you have a complaint. We will do our best to resolve this as soon as possible.",
    "Can we help you with something?": "Can we help you with something?",
    "Do you need a helping hand? We\u2019re here to help you with any questions you may have.": "Do you need a helping hand? We\u2019re here to help you with any questions you may have.",
    "Drag your photo here or use the upload button": "Drag your photo here or use the upload button",
    "SVG, PNG, JPG of GIF (max. 200mb)": "SVG, PNG, JPG or GIF (max. 200mb)",
    "Uploaden": "Upload",
    "Drop your foto here": "Drop your photo here",
    "My favorites": "My favourites",
    "You have no products in your favorites yet.": "You have no products in your favourites yet.",
    "Low stock": "Attention: Very limited stock - availability in store cannot be guaranteed.",
    "Store stock": "Store stock",
    "Put on wishlist": "Add to wishlist",
    "Read more": "Read more",
    "Search suggestions": "Search suggestions",
    "Popular products": "Popular products",
    "Price descending": "Price (Descending)",
    "Price ascending": "Price (Ascending)"
}